export const IP_NOT_ALLOWED_PATH = `/access-denied/ip-not-allowed`;

export const redirectToIpNotAllowed = (): void => {
  if (typeof window === `undefined`) return;
  if (window.location.pathname === IP_NOT_ALLOWED_PATH) return;
  window.location.assign(IP_NOT_ALLOWED_PATH);
};
